import React, { useState } from 'react'
import { useGetCategoriesQuery } from '../../../hooks/library/useGetCategoriesQuery';
import { useNavigate } from 'react-router-dom';
import { routes } from '../../../routes';
import { CategoryType } from '../../../types/Library';
import { useAppDispatch } from '../../../hooks/hooks';
import { useMutation, useQueryClient } from 'react-query';
import { updateCategory } from '../../../services/library/category';
import { key_categories } from '../../../utils/constants';
import toast from 'react-hot-toast';
import { setCategoryData } from '../../../redux/slices/library/category';
import { Pencil1Icon, TrashIcon } from '@radix-ui/react-icons';
import { ConfirmAlertDialog } from '../../../components/common/ConfirmAlertDialog';
import TableComponent from '../../../components/common/Tables';
import { Lists } from '../../../components/common/Lists';

const columnNamesMap: { [key: string]: string } = {
    description: 'Categoria',
};

export const Categories = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [deleteItem, setDeleteItem] = useState<CategoryType | null>(null);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const queryClient = useQueryClient();

    const { data, status } = useGetCategoriesQuery({ PageNumber: currentPage, PageSize: 10 });
    const mutationUpdate = useMutation(updateCategory, {
        onSuccess: () => {
            queryClient.invalidateQueries(key_categories);
            toast.success('Categoria  apagada');
        },
        onError: () => {
            toast.error("Erro ao apagar Categoria.")
        }
    });
    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };
    const handleClickCreate = (event: any): void => {
        navigate(routes.createCategory);
    }
    const handleDelete = (c: CategoryType) => {
        c.status = false;
        mutationUpdate.mutateAsync(c)
      };
      const openDeleteDialog = (s: CategoryType) => {
        setDeleteItem(s);
      };  
      const confirmDelete = async () => {
        if (deleteItem) {
            await handleDelete(deleteItem!)
        }
      };
      const handleEdit = (c: CategoryType) => {
        dispatch(setCategoryData(c));
        navigate(routes.updateCategory)
      };

      const options = data?.items.map((c: CategoryType) => [
        {
            label: 'Editar',
            onClick: () => handleEdit(c),
            icon: <Pencil1Icon />
        },
        {
            label: 'Excluir',
            onClick: () => openDeleteDialog(c),
            icon: <TrashIcon />
        }
      ]) || [];
      return (
        <>
            <Lists
                status={status}
                TableComponent={() =>
                    <TableComponent
                        columns={Object.keys(columnNamesMap)}
                        items={data?.items}
                        options={options}
                        columnNamesMap={columnNamesMap}
                        totalPages={data?.totalPages || 1}
                        currentPage={currentPage}
                        onPageChange={handlePageChange}
                    />
                }
                handleClickCreate={handleClickCreate}
            />
            <ConfirmAlertDialog
                open={!!deleteItem}
                onOpenChange={(open) => !open && setDeleteItem(null)}
                title="Esta operação é irreversível"
                item={deleteItem}
                onConfirm={confirmDelete}
                onCancel={() => setDeleteItem(null)}
            />
        </>
      );
}
